import { EditIntegrationChannelDrawerContent } from '@modules/integrationsV2/components/EditIntegrationChannelDrawer/EditIntegrationChannelDrawerContent';
import { EditIntegrationChannelDrawerContentProps } from '@modules/integrationsV2/types';
import { Box, Drawer } from '@mui/material';

export const EditIntegrationChannelDrawer = ({
  isOpen,
  onDrawerClose,
  integrationID,
  integrationType,
  integrationChannel,
  channelID,
  channelName,
  channelDescriptions,
}: EditIntegrationChannelDrawerContentProps & {
  isOpen: boolean;
}) => {
  return (
    <Drawer
      open={isOpen}
      anchor="right"
      onClose={onDrawerClose}
      keepMounted={false}
    >
      <Box width="45vw" minWidth="700px" height="100vh" overflow="auto">
        <EditIntegrationChannelDrawerContent
          onDrawerClose={onDrawerClose}
          integrationID={integrationID}
          integrationChannel={integrationChannel}
          integrationType={integrationType}
          channelID={channelID}
          channelName={channelName}
          channelDescriptions={channelDescriptions}
        />
      </Box>
    </Drawer>
  );
};
